<template>
  <div class="container-cid">
    <router-link
      class="container-cid-in"
      :to="`/productDetail/${product.id}?sessionToken=${this.$route.query.sessionToken}&apartmentId=${this.$route.query.apartmentId}`"
    >
      <p class="sale" v-if="product.sale">SALE</p>
      <img v-if="product.attributes.images.length > 0" :src="product.attributes.images[0]._url" />
      <p class="product-name">{{product.attributes.name}}</p>
      <div class="viwe-detail">
        <p>ดูรายละเอียดเพิ่มเติม</p>
        <i class="fa fa-angle-right"></i>
        <i class="fa fa-angle-right"></i>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["product"]
};
</script>
